/**
 * Add custom event to Google Tag Manager
 *
 * @param {string} event - The custom event name to be mapped in GTM
 * @param {object} data - The custom event data to be used in GTM
 * @param {boolean} clear - Clear the dataLayer before push the new event (true by default)
 * */
export function addCustomGTMEvent({ event, data, clear = true }) {
  if (typeof window === 'undefined') return;
  if (clear) window?.dataLayer.push({});

  window?.dataLayer.push({
    event,
    ...data,
  });
}

// deve ser usado dentro das views ???
export function addCustomGTMEventOnLoad({ event, data, clear = true }) {
  if (typeof window !== 'undefined') {
    const others = window.dataLayer || [];

    window.dataLayer = [...others];

    if (clear) window.dataLayer.push({});

    window.dataLayer.push({
      event,
      ...data,
    });
  }
}
